import React from "react";
import { useFavoriteMarkets } from "../../common/favorite-markets/FavoriteMarkets";
import Bets from "./Bets";
import EventFetcher from "./EventFetcher";
import InfoMessage from "../../common/InfoMessage";
import { getLabel } from "../../InitData";

export default function FavoriteMarkets(props) {
    const event = props.event;
    const favorites = useFavoriteMarkets();

    if (favorites == null || Object.keys(favorites).length === 0) {
        return <InfoMessage text={getLabel('general.no_results')} />;
    }
    
    return (
        <EventFetcher data={event} renderItem={data => {
                const bets = data.bets.filter(b => favorites[b.id] != null);
                return (
                    <div className="c_17_2">
                        <Bets bets={bets} team1={event.team1} team2={event.team2} />
                    </div>
                );
            }}
        />
    );
}
